import React, {Component} from 'react'
import Header from '../DefaultLayout/Header'
import Footer from '../DefaultLayout/Footer'



class Businesses extends Component{
    render(){
        return(
            <div>
                <Header/>
                <h2>Businesses</h2>
                <Footer/>
            </div>
        )
    }
}

export default Businesses;